module.exports = __webpack_public_path__ + "img/InicioSoloCirculos.d13668a7.png";